/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber4 = createReactComponent("number-4", "IconNumber4", [
  ["path", { d: "M15 20v-15l-8 11h10", key: "svg-0" }]
]);

export { IconNumber4 as default };
//# sourceMappingURL=IconNumber4.js.map
